import React, { Component } from "react";
import { connect } from "react-redux";
import Paper from "material-ui/Paper";
import Snackbar from "material-ui/Snackbar";
import { setTitle } from "../actions/topbar.actions";
import * as authActions from "../actions/auth.actions";
import SignupForm from "../components/SignupForm";

const style = {
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
  },
  paper: {
    color: "rgba(0, 0, 0, 0.87)",
    backgroundColor: "rgb(255, 255, 255)",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    fontFamily: "Roboto, sans-serif",
    padding: 40,
    marginLeft: 16,
    marginRight: 16,
    marginTop: 16,
    marginBottom: 16,
    maxWidth: 768,
    borderRadius: 25,
  },
};

class Signup extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  state = {
    snackBarOpen: false,
  };

  componentWillMount() {
    this.props.setTitle("Sign Up");
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.auth.authenticated) {
      const nextRoute =
        (this.props.location &&
          this.props.location.state &&
          this.props.location.state.from) ||
        "/";
      this.context.router.push(nextRoute);
      return false;
    }

    return true;
  }

  handleFormSubmit = (data) => {
    console.log(data);
  };

  handleRequestClose = () => {
    console.log("close");
  };

  render() {
    const {
      handleSubmit,
      pristine,
      reset,
      submitting,
      valid,
      auth: { authenticating, error },
    } = this.props;

    const errorMessage = (error && error.message) || "";

    return (
      <div
        style={{
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
        }}
      >
        <Paper style={style.paper} zDepth={3}>
          <SignupForm
            onSubmit={this.props.signup}
            loading={authenticating}
            {...this.props}
          />
        </Paper>
        <Snackbar
          open={error !== null}
          message={errorMessage}
          autoHideDuration={4000}
          onRequestClose={this.props.clearLoginError}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export default connect(mapStateToProps, { setTitle, ...authActions })(Signup);



// WEBPACK FOOTER //
// ./src/pages/SignUp.js